/* eslint-disable react/jsx-no-target-blank */
import React from 'react'
// import {useIntl} from 'react-intl'
// import {KTIcon} from '../../../../helpers'
// import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {SidebarMenuItem} from './SidebarMenuItem'
import {useAuth} from '../../../../../app/modules/auth'
import {UserRole} from '../../../../../app/modules/auth'

const SidebarMenuMain = () => {
  // const intl = useIntl()
  const {currentUser, auth} = useAuth()

  const salaDeSituacaoUrl = window.location.hostname.includes('localhost')
    ? 'http://sala-de-situacao.localhost:3001' 
    : 'https://sala-situacao.institutocultiva.com.br';

  return (
    <>
      {/* Common Menu Items */}
      {currentUser?.role.includes(UserRole.ADMINISTRATOR) && (
        <SidebarMenuItem to='/home' title='Dashboard' icon='/media/icons/cultiva/home-small.png' />
      )}

      {/* Role-Specific Menu Items */}
      {(currentUser?.role.includes(UserRole.ADMINISTRATOR) ||
        currentUser?.role.includes(UserRole.CONSULTOR) ||
        currentUser?.role.includes(UserRole.REVIEWER)) && (
        <div className='menu-item'>
          <a
            className='menu-link without-sub'
            href={`${salaDeSituacaoUrl}?token=${auth}`}
            target='_blank'
            rel='noopener noreferrer'
          >
            <img src='/media/icons/cultiva/home-small.png' alt='' style={{maxWidth: '25px', maxHeight: '25px', marginRight: '8px'}} />
            <span className='menu-title'>Sala de Situação</span>
          </a>
        </div>
      )}
      {currentUser?.role.includes(UserRole.ADMINISTRATOR) && (
        <>
          {/* <h3
            style={{
              color: 'white',
              paddingLeft: '15px',
              fontWeight: 'bold',
              paddingTop: '1rem',
              borderTop: '1px solid white',
            }}
          >
            Fluxos
          </h3> */}
          <SidebarMenuItem
            to='/cadastros'
            title='Cadastros'
            icon='/media/icons/cultiva/cadastros-small.png'
          />
        </>
      )}
      {(currentUser?.role.includes(UserRole.ARTICULATOR) ||
        currentUser?.role.includes(UserRole.ADMINISTRATOR) ||
        currentUser?.role.includes(UserRole.MANAGER) ||
        currentUser?.role.includes(UserRole.CONSULTOR) ||
        currentUser?.role.includes(UserRole.REVIEWER)) && (
        <>
          <SidebarMenuItem
            to='/articulador'
            title='Formulários'
            icon='/media/icons/cultiva/formulario-small.png'
          />
        </>
      )}
      {(currentUser?.role.includes(UserRole.CONSULTOR) ||
        currentUser?.role.includes(UserRole.ADMINISTRATOR) ||
        currentUser?.role.includes(UserRole.MANAGER) ||
        currentUser?.role.includes(UserRole.REVIEWER)) && (
        <>
          <SidebarMenuItem
            to='/consultor'
            title='Encaminhamentos'
            icon='/media/icons/cultiva/Encaminhamentos.png'
          />
        </>
      )}
      {(currentUser?.role.includes(UserRole.ADMINISTRATOR) ||
        currentUser?.role.includes(UserRole.MANAGER) ||
        currentUser?.role.includes(UserRole.REVIEWER)) && (
        <>
          <SidebarMenuItem to='/revisor' title='Revisões' icon='/media/icons/cultiva/Revisão.png' />
        </>
      )}
      {(currentUser?.role.includes(UserRole.ARTICULATOR) ||
        currentUser?.role.includes(UserRole.ADMINISTRATOR) ||
        currentUser?.role.includes(UserRole.TEACHER) ||
        currentUser?.role.includes(UserRole.MANAGER)) && (
        <>
          <SidebarMenuItem to='/professor' title='Casos' icon='/media/icons/cultiva/Casos.png' />
        </>
      )}

      {(currentUser?.role.includes(UserRole.ARTICULATOR)) && (
        <>
          <SidebarMenuItem
            to='/focal'
            title='Casos/Encaminhamentos'
            icon='/media/icons/cultiva/Retornos.png'
          />
        </>
      )}
      {(currentUser?.role.includes(UserRole.ADMINISTRATOR) ||
        currentUser?.role.includes(UserRole.ARTICULATOR) ||
        currentUser?.role.includes(UserRole.MANAGER) ||
        currentUser?.role.includes(UserRole.REVIEWER) ||
        currentUser?.role.includes(UserRole.CONSULTOR)) && (
        <>
          <SidebarMenuItem to='/focal' title='Retornos' icon='/media/icons/cultiva/Retornos.png' />
        </>
      )}
      {(currentUser?.role.includes(UserRole.ADMINISTRATOR) ||
        currentUser?.role.includes(UserRole.CONSULTOR) ||
        currentUser?.role.includes(UserRole.REVIEWER)) && (
        <SidebarMenuItem
          to='/relatorio'
          title='Relatório'
          icon='/media/icons/cultiva/relatorio-small.png'
        />
      )}
    </>
  )
}

export {SidebarMenuMain}
